

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { RouterLink, RouterView } from 'vue-router'

export default {
  name: 'app',
}
</script>
<style lang="scss">
/************************************************************
  ** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
  ** 否则页面将无法正常显示                                  **
  ************************************************************/


html {
  font-size: 100px;
}

@media screen and (min-width: 1921px) {
  html {
    font-size: 110px;
  }
}

@media screen and (min-width: 2561px) {
  html {
    font-size: 150px;
  }
}

@media screen and (max-width: 1600px) {
  html {
    font-size: 90px;
  }
}

@media screen and (max-width: 1536px) {
  html {
    font-size: 82px;
  }
}

@media screen and (max-width: 1440px) {
  html {
    font-size: 80px;
  }
}

@media screen and (max-width: 1366px) {
  html {
    font-size: 75px;
  }
}

@media screen and (max-width: 1280px) {
  html {
    font-size: 70px;
  }
}

@media screen and (max-width: 1100px) {
  html {
    font-size: 60px;
  }
}

@media screen and (max-width: 1024px) {
  html {
    font-size: 100px;
  }
}

@media screen and (max-width: 1000px) and (orientation: landscape) {
  html {
    font-size: 55px;
  }

}


@media screen and (max-width: 800px) {
  html {
    font-size: 70px;
  }
}


@media screen and (max-width: 750px) {
  html {
    font-size: 100px;
  }
}

@media screen and (max-width: 640px) {
  html {
    font-size: 85.33px;
  }
}

@media screen and (max-width: 591px) {
  html {
    font-size: 78.8px;
  }
}

@media screen and (max-width: 562px) {
  html {
    font-size: 74.933px;
  }
}

@media screen and (max-width: 540px) {
  html {
    font-size: 72px;
  }
}

@media screen and (max-width: 521px) {
  html {
    font-size: 69.4666px;
  }
}

@media screen and (max-width: 428px) {
  html {
    font-size: 57.066px;
  }
}

@media screen and (max-width: 414px) {
  html {
    font-size: 55.2px;
  }
}

@media screen and (max-width: 412px) {
  html {
    font-size: 54.933px;
  }
}

@media screen and (max-width: 375px) {
  html {
    font-size: 50px;
  }
}

@media screen and (max-width: 360px) {
  html {
    font-size: 48px;
  }
}

@media screen and (max-width: 320px) {
  html {
    font-size: 42.66px;
  }
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    'Microsoft Yahei', sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.pub-flex-row {
  display: flex;
  flex-direction: row;
}

.pub-flex-col {
  display: flex;
  flex-direction: column;
}

.pub-justify-start {
  justify-content: flex-start;
}

.pub-justify-end {
  justify-content: flex-end;
}

.pub-justify-center {
  justify-content: center;
}

.pub-justify-between {
  justify-content: space-between;
}

.pub-justify-around {
  justify-content: space-around;
}

.pub-justify-evenly {
  justify-content: space-evenly;
}

.pub-items-start {
  align-items: flex-start;
}

.pub-items-end {
  align-items: flex-end;
}

.pub-items-center {
  align-items: center;
}

.pub-items-baseline {
  align-items: baseline;
}

.pub-items-stretch {
  align-items: stretch;
}

.pub-self-start {
  align-self: flex-start;
}

.pub-self-end {
  align-self: flex-end;
}

.pub-self-center {
  align-self: center;
}

.pub-self-baseline {
  align-self: baseline;
}

.pub-self-stretch {
  align-self: stretch;
}

.pub-flex-1 {
  flex: 1 1 0%;
}

.pub-flex-auto {
  flex: 1 1 auto;
}

.pub-grow {
  flex-grow: 1;
}

.pub-grow-0 {
  flex-grow: 0;
}

.pub-shrink {
  flex-shrink: 1;
}

.pub-shrink-0 {
  flex-shrink: 0;
}

.pub-relative {
  position: relative;
}

.pub-cf_sidebar_wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.pub-cf_sidebar_content_wrapper {
  flex: 1;
}

.pub-van-cell * {
  flex-shrink: unset;
}

.page {

  // padding-top: 1.47rem;
  .pub_img_box {
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      display: block;
      margin-top: 100%;
    }

    img,
    .pub_img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      left: 0;
      top: 0;
      display: block;
      transition: transform .5s ease;
    }
  }

  .section_001 {
    padding-left: calc(50% - 6.875rem);
    background-image: url('assets/bcfe7bfc2e9a0cb8f6f7cfd41b81752c.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .group_3 {
      margin-top: 1.72rem;

      .image_3 {
        margin-top: 0.99rem;
      }

      .space-y-31 {
        &>*:not(:first-child) {
          margin-top: 0.31rem;
        }

        .text_5 {
          color: rgb(255, 63, 61);
          font-size: 0.78rem;
          font-family: PingFangSC;
          line-height: 0.58rem;
        }

        .text_6 {
          color: rgb(0, 0, 0);
          font-size: 0.42rem;
          font-family: PingFang;
          line-height: 0.4rem;
        }
      }
    }

    .space-x-177 {
      &>*:not(:first-child) {
        margin-left: 1.77rem;
      }
    }

    .image-wrapper {
      padding: 2.7rem 0 2.57rem;
      background-image: url('assets/8664bc65f05bf8f236237d7cf6db21a7.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 8.58rem;
      height: 5.69rem;

      .image_4 {
        margin-right: 0.71rem;
      }
    }

    .image_2 {
      width: 0.24rem;
      height: 0.42rem;
    }
  }

  @media screen and (orientation: landscape) {
    .m_sty {
      display: none !important;
    }
  }

  @media screen and (orientation: portrait) {
    .pc_sty {
      display: none !important;
    }


    .section_001 {
      padding-left: .38rem;
      height: 3.47rem;
      overflow: hidden;
      .group_3 {
        margin-top: 0;
        height: 100%;
        display: flex;
        align-items: center;

        .space-y-31 {
          .text_5 {
            font-size: 0.61rem;
            line-height: 1;
          }

          .text_6 {
            font-size: 0.33rem;
            line-height:1;
            margin-top: .24rem;
          }
        }
      }
      .image-wrapper {
        padding: 0;
        background-image: url('assets/8664bc65f05bf8f236237d7cf6db21a7.png');
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: left center;
        width: 3.29rem;
        height: 100%;
      }
    }
  }
}
</style>